<div class="login-container" id="slideanimation" *ngIf="login && !confirmCode">
    <div [ngClass]="{'banner-img  col-md-6  col-12': !showPopup , 'banner-img-1  col-md-6  col-12': showPopup}">
        <a style="text-decoration: none;" [routerLink]="['/']">
            <h6 class="Ws-logo-mobile">{{constants.WINDOW_SWAP_TXT}}</h6>
        </a>
        <img [src]="constants.LOGIN_PAGE_IMG" alt="">
        <p class="author">Manasa - Bangalore, India</p>
    </div>
    <div class=" col-md-6 col-12  login-form">
        <a style="text-decoration: none;" [routerLink]="['/']">
            <h6 class="Ws-logo">{{constants.WINDOW_SWAP_TXT}}</h6>
        </a>
        <p class="no-accpunt animate__animated animate__fadeInUp">Don’t have an account? <a [routerLink]="['/signup']"
                class='bold'>Sign up</a></p>
        <button id="text-box-1" type="button" [disabled]="true"
            class="btn btn-lg login-button animate__animated animate__fadeInUp disableFB"
            (click)="onLoginClick('Facebook')"><img class="facebook-img" [src]="constants.LOGIN_FACEBOOK_IMG" alt="">
            {{constants.LOGIN_WITH_FACEBOOK_TXT}}
        </button>
        <button id="text-box-2" type="button" s class="btn btn-lg login-button animate__animated animate__fadeInUp"
            (click)="onLoginClick('Google')"><img class="google-img" [src]="constants.LOGIN_GOOGLE_IMG" alt="">
            {{constants.LOGIN_WITH_GOOGLE_TXT}}
        </button>
        <div>
            <p class="signin-text animate__animated animate__fadeInUp">Login with email</p>
        </div>
        <form [formGroup]="loginForm" (ngSubmit)="onClicklogin()">
            <span id="errorAlert"></span>
            <span id="resend">User is not confirmed.<button [disabled]="isLoading" class='resend'
                    (click)='onClickResend()'>Resend verification code
                    Confirmation.</button></span>
            <span class="input-text-required"
                *ngIf="loginForm.get('email').errors?.required && (loginForm.get('email').dirty || loginForm.get('email').touched)">
                Please enter an email ID<br></span>
            <span class="input-text-required" *ngIf="loginForm.get('email').errors?.email">
                Invalid email ID </span>
            <input type="email" class="input-text animate__animated animate__fadeInUp" placeholder="Your Email Address"
                formControlName="email">
            <span class="input-text-required"
                *ngIf="loginForm.get('password').errors?.required && (loginForm.get('password').dirty || loginForm.get('password').touched)">
                Please enter a password </span>
            <div class="password-container animate__animated animate__fadeInUp">
                <input class="input-text " id="input-password" type="password" placeholder="Password"
                    formControlName="password">
                <i (click)="onClickSowPassowrd()" class="fa fa-eye password-show"></i>
            </div>
            <button [disabled]="isProcessing || !loginForm.valid" type="submit"
                class="login-email-button animate__animated animate__fadeInUp">
                <span *ngIf="isProcessing" class="spinner-border spinner-border-sm" role="status"
                    aria-hidden="true"></span> Login </button>
            <a class="forgot-passowrd animate__animated animate__fadeInUp" (click)="onClickForgot()">Forgot Password</a>
        </form>
        <div class="modal-popup" id="modal-popup-confirm" *ngIf="showPopup">
            <div class="confirm-popup-content popup-content-confirm">
                <p>Welcome Back!</p>
                <h1>It looks like you usually login</h1>
                <h1 *ngIf="this.loginMethod === 'email'">with your email id</h1>
                <h1 *ngIf="this.loginMethod === 'social'">with a social account</h1>
                <button type="button" class="okay-button" (click)="okayClicked()">
                    Okay
                </button>
            </div>
        </div>
    </div>
    <div class=" close-button-container">
        <a (click)="gotoPrevious()">
            <img class="login-close-button" id="close-button" [src]="constants.BACK_BUTTON" alt="close-button" />
        </a>
    </div>
</div>
<div class="container-fluid reset-form-container" *ngIf="!login && !confirmCode">
    <div class="row justify-content-center align-items-center" style="height: 100vh;">
        <div class=" col-md-6">
            <p class="logo animate__animated animate__fadeInUp">WindowSwap</p>
            <p class="logo-sub-head animate__animated animate__fadeInUp">Enter the email address associated with your
                account<br>
                and we will send you a link to reset your password.</p>
            <form [formGroup]="resendForm" class="reset-form">
                <span id="errorAlert"></span>
                <span class="input-text-required"
                    *ngIf="resendForm.get('email').errors?.required && (resendForm.get('email').dirty || resendForm.get('email').touched)">
                    Please enter an email ID <br></span>
                <span class="input-text-required" *ngIf="resendForm.get('email').errors?.email">
                    Invalid email ID </span>
                <input type="email" class="input-text animate__animated animate__fadeInUp"
                    placeholder="Your Email Address" formControlName="email">
                <button [disabled]="isProcessing || !resendForm.valid"
                    class="login-email-button animate__animated animate__fadeInUp" (click)="onClickVerify()">
                    <span *ngIf="isProcessing" class="spinner-border spinner-border-sm" role="status"
                        aria-hidden="true"></span>
                    Verify </button>
            </form>
        </div>
        <div class=" close-button-container">
            <a href="/login">
                <img class="login-close-button" id="close-button" [src]="constants.BACK_BUTTON" alt="close-button" />
            </a>
        </div>
    </div>
</div>
<div class="container-fluid reset-form-container" *ngIf="!login && confirmCode">
    <div class="row justify-content-center align-items-center" style="height: 100vh;">
        <div class=" col-md-6">
            <p class="logo animate__animated animate__fadeInUp">WindowSwap</p>
            <p class="logo-sub-head animate__animated animate__fadeInUp">Enter the verification code emailed to you,<br>
                and then create a new password</p>
            <form [formGroup]="confirmResendForm" class="reset-form">
                <span id="errorAlert"></span>
                <input [attr.disabled]='true' type="email" class="input-text animate__animated animate__fadeInUp"
                    formControlName="email">
                <span class="input-text-required"
                    *ngIf="confirmResendForm.get('code').errors?.required && (confirmResendForm.get('code').dirty || confirmResendForm.get('code').touched)">
                    Please enter the Verification code </span>
                <input type="text" class="input-text animate__animated animate__fadeInUp"
                    placeholder="Verification code" formControlName="code">
                <span class="input-text-required"
                    *ngIf="confirmResendForm.get('password').errors?.required && (confirmResendForm.get('password').dirty || confirmResendForm.get('password').touched)">
                    Please enter a password </span>
                <span class="input-text-required" *ngIf="confirmResendForm.get('password').errors?.pattern">
                    A strong password is at least 8 characters and a mix of uppercase, and lowercase letters, symbols
                    ($&#64;#!%*?&), and numbers.</span>
                <div class="password-container animate__animated animate__fadeInUp">
                    <input class="input-text " id="input-password" type="password" placeholder="Password"
                        formControlName="password">
                    <i (click)="onClickSowPassowrd()" class="fa fa-eye password-show"></i>
                </div>
                <button [disabled]="isProcessing || !confirmResendForm.valid"
                    class="login-email-button animate__animated animate__fadeInUp" (click)="onClickConfirmSubmit()">
                    <span *ngIf="isProcessing" class="spinner-border spinner-border-sm" role="status"
                        aria-hidden="true"></span>
                    Submit </button>
            </form>
        </div>
    </div>
    <div class=" close-button-container">
        <a [routerLink]="['/']">
            <img class="login-close-button" id="close-button" [src]="constants.BACK_BUTTON" alt="close-button" />
        </a>
    </div>
</div>

<!-- <div class="modal-popup" id="modal-popup-confirm">
    <div class="confirm-popup-content popup-content-confirm">
        <p>Welcome Back!</p>
        <h1>It looks like you usually login</h1>
        <h1>with a social account</h1>
        <button type="button" class="okay-button">
            Okay
        </button>
    </div>
</div> -->